import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'

interface MoreSheetProps {
  open: boolean
  onClose: () => void
}

const LINKS: { to: string; label: string }[] = [
  { to: '/imports', label: 'Imports' },
  { to: '/strategy', label: 'Strategie' },
  { to: '/strategy/history', label: 'Strategie-Historie' },
  { to: '/profit-taking', label: 'Profit-Taking' },
  { to: '/rebalance', label: 'Rebalance' },
  { to: '/asset-check', label: 'Asset-Check' },
  { to: '/onboarding', label: 'Onboarding' },
]

export function MoreSheet({ open, onClose }: MoreSheetProps) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <>
      <div
        data-testid="more-sheet-backdrop"
        className="fixed inset-0 z-40 bg-void/70"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Weitere Seiten"
        className="fixed inset-x-0 bottom-0 z-50 max-h-[60vh] overflow-y-auto border-t border-hairline bg-panel"
      >
        <nav className="flex flex-col">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={onClose}
              className={({ isActive }) =>
                [
                  'min-h-[44px] border-b border-hairline px-4 py-3 text-sm transition-colors',
                  isActive ? 'text-bernstein' : 'text-muted hover:text-ink',
                ].join(' ')
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </>
  )
}
